
import { useEffect, useState } from "react";
import TapSelect from "../../../components/ui/TapSelect";
import Loader from "../../../components/ui/Loader/Loader";
import tapIcon from '../../../services/TapIcon';
import ApplicationLayout from "../../../layouts/ApplicationLayout";
import { Helmet } from "react-helmet";
import HttpAPICall from "../../../services/HttpAPICall";
import { BACKOFFICE_BASE_URL } from "../../../services/TapApiUrls";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";

const AddAssetMatrix = ({location}) => {
    
    const assetMatrixUrl    =   BACKOFFICE_BASE_URL + '/asset_matrix';
    const access_token      =   useSelector(state => state.auth.access_token);
    const history           =   useHistory();


    const initAddFormData   =   {
        asset_type_id           :   '',
        manufacturer_id         :   '',
        model_id                :   '',
        variant                 :   '',
        electrical_system       :   '',
        fuel_type_id            :   '',
        fuel_tank_capacity      :   '',
        asset_capacity          :   '',
    };

    const [formData, setFormData]           =   useState({
        loading             :   false,
        assetTypesMeters    :   [],
        assetTypes          :   [],
        manufacturers       :   [],
        models              :   [],
        electricalSystem    :   [],
        fuelTypes           :   [],
    });
    const [allMeters, setAllMeters]         =   useState([]);
    const [isAssetLink, setIsAssetLink]     =   useState(false);

    const [submitData, setSubmitData]   =   useState({
        submitLoading   :   false,
        addFormData     :   initAddFormData
    })

    const [editId, setEditId]   =   useState(null);

    useEffect(() => {
        initialFormData();
    }, []);

    useEffect(() => {
        if(editId) {
            detailData();
        }
    }, [editId])


    const initialFormData   =   ()  => {
        setFormData(pre => ({...pre, loading : true}));
        HttpAPICall.withAthorization('GET', assetMatrixUrl + '/form_data', access_token, {}, {}, (resp) => {
            const {asset_type, manufacturers, electrical_system, fuel_type, all_meters}   =   resp.data;
            let electricalSystem    =   [];
            for (const key in electrical_system) {
                electricalSystem    =   [...electricalSystem, { label : electrical_system[key], value: electrical_system[key] }]
            }
            setSubmitData(pre => ({...pre, addFormData : initAddFormData}))
            setFormData(pre => ({
                ...pre, 
                assetTypesMeters:   asset_type,
                assetTypes      :   asset_type.map(at => ({ label : at.asset_type_name, value: at.id })),
                manufacturers   :   manufacturers.map(mf => ({ label : mf.manufacturer, value: mf.id, models:  mf.models})),
                electricalSystem,
                fuelTypes       :   fuel_type.map(ft => ({ label : ft.fuel_type, value: ft.id })),   
            }));
            setAllMeters(all_meters.map(m => ({...m, checked : false, label : '', limit : m.unit === 'Hr' ? 24 : ''})));
        }).then(() => {
            const queryParams = new URLSearchParams(location.search);
            if(queryParams && queryParams.get('asset_matrix_id')) {
                setEditId(queryParams.get('asset_matrix_id'));
            }else {
                setFormData(pre => ({...pre, loading : false}));
            }
        });
    }

    const detailData    =   () => {
        setEditId(editId);
        HttpAPICall.withAthorization('GET', assetMatrixUrl + '/detail/' + editId, access_token, {}, {}, (resp) => {

            const respData  =   resp.data;
            const meter_data=   respData.meter_data;
            if(meter_data.length > 0) {
                let meterData  =   allMeters.map(am => {
                    const meter     =   meter_data.find(md => md.key === am.key);
                    return meter ? {...am, label: meter.label, limit: meter.limit, checked: meter.available === 'Y' ? true : false} : am;
                }); 
                setAllMeters(meterData);                   
            }

            const manufacturer_id   =   respData.manufacturer?.id
            if(manufacturer_id) {
                setFormData(pre => ({
                    ...pre,
                    models : formData.manufacturers.find(m => m.value === manufacturer_id).models.map(m => ({ label : m.model, value: m.id }))
                }));
            }
            setIsAssetLink(respData.link_with_asset);
            setSubmitData(pre => ({
                ...pre,
                addFormData : {
                    am_id                   :   editId,
                    asset_type_id           :   respData.asset_type?.id,
                    manufacturer_id,
                    model_id                :   respData.model?.id,
                    variant                 :   respData.variant,
                    electrical_system       :   respData.electrical_system,
                    fuel_type_id            :   respData.fuel_type?.id,
                    fuel_tank_capacity      :   respData.fuel_tank_capacity,
                    asset_capacity          :   respData.capacity,     
                } 
            }))   
        }).finally(() => setFormData(pre => ({...pre, loading : false})));
    }


    const formInputHandler = (e) => {
        setSubmitData(pre => ({ ...pre, addFormData: {...submitData.addFormData, [e.target.name]: e.target.value }}));
    };

    const handleCheckboxChange = (index) => {
        const updatedMeters = [...allMeters];
        updatedMeters[index] = {
            ...updatedMeters[index],
            checked: !updatedMeters[index].checked
        };
        setAllMeters(updatedMeters);
    };

    const handleInputChange = (index, field, value) => {
        const updatedMeters = [...allMeters];
        updatedMeters[index] = {
            ...updatedMeters[index],
            [field]: value
        };
        setAllMeters(updatedMeters);
    };

    const selectTapHandle   =   (selectedOption, name)  => {
        if(selectedOption) {
            setSubmitData(pre => ({
                ...pre,
                addFormData : {...submitData.addFormData, [name] : selectedOption.value }
            }));

            if(name === 'manufacturer_id') {
                setFormData(pre => ({
                    ...pre,
                    models : selectedOption.models.map(m => ({ label : m.model, value: m.id })),
                }));
            }

        }else {
            setSubmitData(pre => ({
                ...pre,
                addFormData : {...submitData.addFormData, [name] : '' }
            }));
        }
    }
    const handleAssetTypeMeter  =   (selectedOption)  => {
        if(selectedOption) {
            const atMeters      =   formData.assetTypesMeters.find(at => at.id === selectedOption.value);
            
            let allMetersData   =   allMeters.map(m => {
                let checked         =   atMeters[m.key] === 'yes' ? true : false; 
                return {...m, checked}
            });
            setAllMeters(allMetersData);

        }else {
            setAllMeters(allMeters.map(am => ({...am, checked : false})));
        }
    }

    const submitDataForm = (e) => {
        e.preventDefault();

        setSubmitData(pre => ({...pre, submitLoading : true}));

        let meters                  =   allMeters.reduce((acc, am) => {
            return {
                ...acc,
                [`${am.key}_label`]: am.label,
                [`${am.key}_limit`]: am.limit,
                [am.key]: am.checked ? 'Y' : 'N'
            };
        }, {});
        let method  =   'POST';
        let url     =   assetMatrixUrl + '/add';
        let payload =   {...submitData.addFormData, ...meters};
        if(editId) {
            method  =   'PUT';
            url     =   assetMatrixUrl + '/edit';
            payload =   {...payload, id : editId};
        }

        HttpAPICall.withAthorization(method, url, access_token, {}, payload, (resp) => {
            toast.success(resp.data.msg, { position: toast.POSITION.TOP_RIGHT });
            goToList();
         }).catch((error) => {
            toast.error(error.response?.data?.msg || "An error occurred", { position: toast.POSITION.TOP_RIGHT });
        }).finally(() => {
            setSubmitData(pre => ({...pre, submitLoading : false}));
        });

    };

    const goToList   =  () => {
        history.push({
            pathname: '/asset_matrix_list',
            state: { assetMatrixId: editId }
        });
    }

    const saveFormJsx   =   () => {
        const {loading, assetTypes, manufacturers, models, electricalSystem, fuelTypes}    =   formData;
        const {submitLoading, addFormData}    =   submitData;
        return(
            <form className="bg-white p-3" onSubmit={submitDataForm} id="saveResourceForm">
                {loading ? <Loader />
                    : 
                    <>
                    <div className="row align-items-center my-3">
                        <div className="col-sm-3">
                            <label htmlFor="path" className="form-label">Asset Type</label>
                        </div>
                        <div className="col-sm-8 ">
                            <TapSelect
                                changeEvent={(selectedOption) => {
                                    selectTapHandle(selectedOption, 'asset_type_id');
                                    handleAssetTypeMeter(selectedOption);
                                }}
                                options={assetTypes}
                                isSearchable={true}
                                isClearable={true}
                                required={true}
                                isDisabled={editId ? true : false}
                                value={assetTypes.find(s => addFormData.asset_type_id == s.value)}
                                placeholder={"Please Select Asset Type"}
                                containerHeight="30px"
                                fontSize="93%"
                            />
                        </div>
                    </div>
                    <div className="row align-items-center my-3">
                        <div className="col-sm-3">
                            <label htmlFor="manufacturer" className="form-label">Manufacturer</label>
                        </div>
                        <div className="col-sm-8 ">
                            <TapSelect
                                changeEvent={(selectedOption) => selectTapHandle(selectedOption, 'manufacturer_id')}
                                options={manufacturers}
                                isSearchable={true}
                                isClearable={true}
                                value={manufacturers.find(s => addFormData.manufacturer_id == s.value)}
                                isDisabled={isAssetLink}
                                placeholder={"Please Select Manufacturer"}
                                containerHeight="30px"
                                fontSize="93%"
                            />
                        </div>
                    </div>
                    <div className="row align-items-center my-3">
                        <div className="col-sm-3">
                            <label htmlFor="model" className="form-label">Model</label>
                        </div>
                        <div className="col-sm-8 ">
                            <TapSelect
                                changeEvent={(selectedOption) => selectTapHandle(selectedOption, 'model_id')}
                                options={models}
                                isSearchable={true}
                                isClearable={true}
                                value={models.find(s => addFormData.model_id == s.value)}
                                placeholder={"Please Select Model"}
                                isDisabled={isAssetLink}
                                containerHeight="30px"
                                fontSize="93%"
                            />
                        </div>
                    </div>
                    <div className="row align-items-center my-3">
                        <div className="col-sm-3">
                            <label htmlFor="name" className="form-label require">Variant</label>
                        </div>
                        <div className="col-sm-8 ">
                            <input
                                name="variant"
                                type="text"
                                value={addFormData.variant}
                                className="form-control"
                                autoComplete="off"
                                required={true}
                                disabled={isAssetLink}
                                onChange={formInputHandler}
                                placeholder="Please enter Variant"
                                style={{ height: "30px", fontSize: "93%" }}
                            />
                        </div>
                    </div>
                    <div className="row align-items-center my-3">
                        <div className="col-sm-3">
                            <label htmlFor="electricSystemSpecification" className="form-label">Electric System Specification</label>
                        </div>
                        <div className="col-sm-8 ">
                            <TapSelect
                                changeEvent={(selectedOption) => selectTapHandle(selectedOption, 'electrical_system')}
                                options={electricalSystem}
                                isSearchable={true}
                                isClearable={true}
                                value={electricalSystem.find(s => addFormData.electrical_system == s.value)}
                                placeholder={"Please Select Electrical System"}
                                isDisabled={isAssetLink}
                                containerHeight="30px"
                                fontSize="93%"
                            />
                        </div>
                    </div>
                    <div className="row align-items-center my-3">
                        <div className="col-sm-3">
                            <label htmlFor="fuelType" className="form-label">Fuel Type</label>
                        </div>
                        <div className="col-sm-8 ">
                            <TapSelect
                                changeEvent={(selectedOption) => selectTapHandle(selectedOption, 'fuel_type_id')}
                                options={fuelTypes}
                                isSearchable={true}
                                isClearable={true}
                                value={fuelTypes.find(s => addFormData.fuel_type_id == s.value)}
                                placeholder="Please Select Fuel Type"
                                isDisabled={isAssetLink}
                                containerHeight="30px"
                                fontSize="93%"
                            />
                        </div>
                    </div>
                    <div className="row align-items-center my-3">
                        <div className="col-sm-3">
                            <label htmlFor="fuelTankCapacity" className="form-label">Fuel Tank Capacity</label>
                        </div>
                        <div className="col-sm-8 ">
                            <input
                                name="fuel_tank_capacity"
                                type="text"
                                value={addFormData.fuel_tank_capacity}
                                className="form-control"
                                autoComplete="off"
                                onChange={formInputHandler}
                                disabled={isAssetLink}
                                placeholder="Please enter capacity"
                                style={{ height: "30px", fontSize: "93%" }}
                            />
                        </div>
                    </div>
                    <div className="row align-items-center my-3">
                        <div className="col-sm-3">
                            <label htmlFor="assetCapacity" className="form-label ">Asset Capacity</label>
                        </div>
                        <div className="col-sm-8 ">
                            <input
                                name="asset_capacity"
                                type="text"
                                value={addFormData.asset_capacity}
                                className="form-control"
                                autoComplete="off"
                                onChange={formInputHandler}
                                disabled={isAssetLink}
                                placeholder="Please enter Asset Capacity"
                                style={{ height: "30px", fontSize: "93%" }}
                            />
                        </div>
                    </div>
                    {allMeters.length > 0 && (
                        <div className="mt-3">
                            <h6>Available Meters</h6>
                            <div className="table-responsive">
                                <table className="table table-bordered table-sm">
                                    <thead className="table-secondary">
                                        <tr>
                                            <th className='text-center' style={{ width: "3%" }}>#</th>
                                            <th style={{ width: "15%" }}>Label</th>
                                            <th style={{ width: "15%" }}>Original Name</th>
                                            <th style={{ width: "10%" }}>Limit</th>
                                            <th style={{ width: "10%" }}>Unit</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {allMeters.map((meter, index) => (
                                            <tr key={index}>
                                                <td className='text-center'>
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        checked={meter.checked}
                                                        onChange={() => handleCheckboxChange(index)}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        value={meter.label || ""}
                                                        className="form-control"
                                                        autoComplete="off"
                                                        onChange={(e) => handleInputChange(index, 'label', e.target.value)}
                                                        disabled={!meter.checked}
                                                        style={{ height: "30px", fontSize: "93%" }}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        value={meter.name}
                                                        className="form-control"
                                                        autoComplete="off"
                                                        disabled
                                                        style={{ height: "30px", fontSize: "93%" }}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="number"
                                                        value={meter.limit || ""}
                                                        className="form-control"
                                                        autoComplete="off"
                                                        onChange={(e) => handleInputChange(index, 'limit', e.target.value)}
                                                        disabled={!meter.checked || meter.unit === 'Hr' || isAssetLink}
                                                        style={{ height: "30px", fontSize: "93%" }}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        value={meter.unit}
                                                        className="form-control"
                                                        autoComplete="off"
                                                        disabled
                                                        style={{ height: "30px", fontSize: "93%" }}
                                                    />
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}
                </>
                }
                <div className="col-12 text-end fixed_footer">
                    <button type="button" disabled={submitLoading} onClick={goToList} className="btn btn-secondary mx-3">Cancel</button>
                    <button type="submit" disabled={submitLoading || loading} className="btn btn-primary mx-2">
                        Save {submitLoading ? (<tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin" />) : ''}
                    </button>
                </div>
            </form>
        )
    }  


    return (
        <ApplicationLayout>
            <Helmet><title>Asset Matrix Add</title></Helmet>
            <div className="page_title row m0">
                <div className="col-12">
                    <h3>{editId ? "Edit" : "Add"} Asset Matrix</h3>
                    <div className="text-end mt15">
                        <button type="button" className="btn btn-secondary" onClick={goToList}>
                            <tapIcon.imageIcon icon={tapIcon.CloseIcon} className="img-fluid" alt="Close Asset Type" />
                        </button>
                    </div>
                </div>
            </div>
            {/* onClick={closeEvent} disabled={submitLoading} */}
            <div className="container-fluid">
                <div className="page_containt row pl2">
                    <div className="pageTbl col-12 pl4">
                        {saveFormJsx()}
                    </div>
                </div>
            </div>
        </ApplicationLayout>
    );
};

export default AddAssetMatrix;
